import React, { Component } from "react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import RecipeReviewCard from "./RecipeReviewCard";
import Button from "@material-ui/core/Button";
import PlayWords from "./PlayWords";
import { LoadSpeak } from "./SpeakWords";
import Slide from "@material-ui/core/Slide";
import { bookmarkWords } from "../../store/actions/wordAction";
import { updateUserSettings } from "../../store/actions/wordAction";
import IconButton from "@material-ui/core/IconButton";
import FavoriteIcon from "@material-ui/icons/Favorite";
import SwipeableTemporaryDrawer from "../shared/SwipeableTemporaryDrawer";
import { CookieWords } from "../shared/CookieWords";

import { getFirestore } from "redux-firestore";
import { getDefaultVoices } from "../shared/Voices";
import { fetchMainData } from "./WordCard_SQL";
import { filterBySet } from "./WordCard_SQL";
import {
  changeLevels,
  changeDates,
  fieldUpdate,
} from "../../store/actions/wordAction";
import IframeComponent from "../shared/IframeComponent";
import "./WordCard.scss";

export class WordCard extends Component {
  state = {
    sets: [{ id: "3", name: "3" }],
    // verbs:[{Language1:"",Language2:"",Present:[{}]}],
    verbs: [],
    original_words: [],
    //words:[{Language1:"1",Language2:"2",Language3:"3"}],
    words: [],
    settingSpeak: {
      Right: "Language2",
      Left: "Language2",
      Up: "Language1",
      Down: "Language2",
      SpanishVoice: "",
      GermanVoice: "",
      EnglishVoice: "",
      FrenchVoice: "",
      ItalianVoice: "",
      X: "Description1",
      Y: "Description2",
      A: "Description4",
      B: "Description5",
      Start: "Language1",
      Select: "Language4",
      Speed: 2,
    },
    autoPlaySettings: {
      Language1: false,
      Language2: false,
      Language3: false,
      Language4: true,
      Language5: false,
      Description1: false,
      Description2: false,
      Description3: false,
      Description4: false,
      Description5: false,
      SpeakOnNavigation: true,
      Verzug: 3,
      Order: "Asc",
    },
    mounted: false,
    slide: false,
    // mounted:false,
    // slide:false,
    currentWordId: 0,
    collection_name: "word_set",
    name: "",
    limit: 42,
    document_name: "",

    iframeLanguage: "test",
    iframeText: "",
    iframeShow: false,
    longWords: false,
  };

  changeCurrentID = (id) => {
    this.setState({
      currentWordId: id,
    });

    this.setState({
      slide: false,
    });
    let G_timer = setInterval(() => {
      this.setState({
        slide: true,
      });
      clearInterval(G_timer);
    }, 2);
  };

  handleSettingsChanged = (
    Right,
    Left,
    Up,
    Down,
    SpanishVoice,
    GermanVoice,
    EnglishVoice,
    FrenchVoice,
    ItalianVoice,
    X,
    Y,
    A,
    B,
    Start,
    Select,
    Speed
  ) => {
    var temp = {
      Right: Right,
      Left: Left,
      Up: Up,
      Down: Down,
      SpanishVoice: SpanishVoice,
      GermanVoice: GermanVoice,
      EnglishVoice: EnglishVoice,
      FrenchVoice: FrenchVoice,
      ItalianVoice: ItalianVoice,
      X: X,
      Y: Y,
      A: A,
      B: B,
      Start: Start,
      Select: Select,
      Speed: Speed,
    };
    this.setState({
      settingSpeak: temp,
    });
    let uid = localStorage.getItem("user_id");
    if (uid != "" && uid != undefined) {
      this.props.updateUserSettings(temp, localStorage.getItem("user_id"));
      //alert("update");
    }
  };

  handleAutoPlaySettingsChanged = (autoPlaySettings) => {
    //       alert(autoPlaySettings.Level);
    if (autoPlaySettings.Level > 1) {
      this.FilterByLevel(autoPlaySettings.Level);
    }
    localStorage.setItem("autoPlaySettings", JSON.stringify(autoPlaySettings));
    this.setState({
      autoPlaySettings: autoPlaySettings,
    });
  };

  editWord = (newWord) => {
    let temp = [...this.state.words];
    temp[this.state.currentWordId] = newWord;
    console.log(temp[this.state.currentWordId]);
    this.setState({
      words: temp,
    });
  };

  ReplaceWords = (newWords) => {
    this.setState({
      words: newWords,
      currentWordId: 0,
    });
  };

  ClickLevel = () => {
    //alert(this.state.collection_name);
    var level = this.state.words[this.state.currentWordId].level + 1;
    if (level > 7) {
      level = 1;
    }
    var selected_items = [];
    selected_items[0] = this.state.words[this.state.currentWordId].id;
    this.props.changeLevels(selected_items, level, this.state.collection_name);

    let temp = this.state.words;
    temp[this.state.currentWordId].level = level;
    this.setState({
      words: temp,
    });
  };
  ChangeDate = () => {
    var selected_items = [];
    selected_items[0] = this.state.words[this.state.currentWordId].id;
    console.log(this.state.collection_name);
    this.props.changeDates(selected_items, this.state.collection_name);
  };

  handleIframeChanage = (text, voice) => {
    let lang = "en";
    if (voice === "FrenchVoice") lang = "fr";
    if (voice === "SpanishVoice") lang = "es";
    if (voice === "GermanVoice") lang = "de";
    if (voice === "ItalianVoice") lang = "it";

    this.setState({
      iframeLanguage: lang,
    });
    this.setState({
      iframeText: text,
    });
  };

  IframeToggle = () => {
    this.setState({
      iframeShow: !this.state.iframeShow,
    });
  };

  FilterLongWords(longWords) {
    const long = [
      "Grammar",
      "Imperativ",
      "Imperfect",
      "Past before past",
      "Phrases",
      "Should have /past",
      "Subjunctive",
      "To Sort",
    ];
    let array = this.state.original_words.filter((w) => {
      if (longWords) {
        return !long.includes(w.set);
      }
      return long.includes(w.set);
    });
    this.setState({
      words: array,
    });
  }

  ToggleLongWords = () => {
    this.FilterLongWords(!this.state.longWords);
    this.setState({
      longWords: !this.state.longWords,
    });
  };

  Shuffle = () => {
    let array = this.state.words;
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    this.setState({
      words: array,
    });
  };
  handleBookmark = (booked) => {
    let selected = [];
    selected.push(this.state.words[this.state.currentWordId].id);
    this.props.bookmarkWords(selected, booked, this.state.collection_name);
    let temp = this.state.words;
    temp[this.state.currentWordId].bookmarked = booked;
    this.setState({
      words: temp,
    });
  };

  UpdateField = (field_name, type) => {
    var selected_items = [];
    selected_items[0] = this.state.words[this.state.currentWordId].id;
    this.props.fieldUpdate(selected_items, type, "word_set", field_name);
    let temp = this.state.words;
    temp[this.state.currentWordId].speakExplicit = type;
    this.setState({
      words: temp,
    });
  };

  handleBookmarkFilter = (onoff) => {
    if (onoff) {
      const filteredWords = this.state.original_verbs.filter(
        (el) => el["bookmarked"] == true
      );
      this.setState({
        verbs: filteredWords,
      });
    } else {
      this.setState({
        verbs: this.state.original_verbs,
      });
    }
  };

  //#region MOUNT
  componentDidMount() {}

  componentWillMount() {
    this.fetchMainData(this.state.limit, "word_set");
    let tempAutoPlaySettings = JSON.parse(
      localStorage.getItem("autoPlaySettings")
    );
    if (tempAutoPlaySettings) {
      this.setState({
        autoPlaySettings: tempAutoPlaySettings,
      });
    }
  }
  //#endregion

  //#region SQL

  fetchMainData(limit, collection) {
    let single_document = {};
    let data = [];
    let firestore = getFirestore();

    firestore
      .collection(collection)
      .orderBy("createdAt", "desc")
      .limit(limit)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach(function (doc) {
          single_document = doc.data();
          single_document.id = doc.id;
          data.push(single_document);
        });
        this.setState({
          words: data,
          original_words: data,
          mounted: true,
          slide: true,
        });
        this.ToggleLongWords();
      });
    firestore
      .collection("sets")
      .orderBy("name", "asc")
      .get()
      .then((querySnapshot) => {
        let temp_sets = querySnapshot.docs.map((doc) => doc.data());
        this.setState({
          sets: temp_sets,
        });
      });

    //  alert("get" + localStorage.getItem('user_id'));

    var temp_settings = firestore
      .collection("user_settings")
      .doc(localStorage.getItem("user_id"));

    temp_settings
      .get()
      .then((doc) => {
        if (doc.exists) {
          //          console.log(doc.data());
          this.setState({
            settingSpeak: doc.data(),
          });
          // console.log(this.state.settingSpeak);
        } else {
        }
      })
      .catch(function (error) {
        console.log("Error getting document:", error);
      });

    // firestore.collection("user_settings").get().then((querySnapshot) => {
    //   let temp_user_settings = querySnapshot.docs.map(doc => doc.data());
    //   this.setState({
    //     settingSpeak:temp_user_settings
    // });

    // });
  }

  handleSetFilter = (name, limit, collection, document_name) => {
    this.setState({
      name: name,
      limit: limit,
      collection_name: collection,
      document_name: document_name,
    });
    console.log(collection);
    if (collection == undefined || collection == "") {
      collection = "word_set";
    }
    // console.log(collection)
    let equality;
    let param1;
    let param2 = name;
    if (name == "All") {
      equality = ">=";
      param1 = "set";
      this.fetchMainData(limit, collection);
      return;
    } else if (name == "Bookmarked") {
      equality = "==";
      param1 = "bookmarked";
      param2 = true;
    } else {
      equality = "==";
      //   param1 = "set";
      param1 = document_name;
    }

    if (name == "Bookmarked") {
      this.filterBySetBookmarked(param1, equality, param2, limit, collection);
      // }
      // else if (collection == 'word_temp11') {
      //   this.filterBySetBookmarked(param1, equality, param2, limit, collection)
    } else {
      this.filterBySet(param1, equality, param2, limit, collection);
    }
  };

  //CREATE DATABASE INDEX LING WILL BE IN CONSOLE DEBUGGING BROWSER
  filterBySetBookmarked(param1, equality, param2, limit, collection) {
    let single_document = {};
    const data = [];
    let firestore = getFirestore();
    firestore
      .collection(collection)
      .where(param1, equality, param2)
      //.orderBy("createdAt", "desc")
      .limit(limit)
      .get()
      .then((querySnapshot) => {
        //  firestore.collection("word_set").where("bookmarked","!=", true).orderBy("createdAt", "desc").limit(limit).get().then((querySnapshot) => {
        querySnapshot.forEach(function (doc) {
          single_document = doc.data();
          single_document.id = doc.id;
          data.push(single_document);
        });
        // data = data.sort((a, b) => a.createdAt > b.createdAt);
        this.setState({
          words: data,
          original_words: data,
        });
      });
  }

  //ERSTELL EIN NEUES INDEX LINK IST IN CONSOLE DES BROWSER DEBUGGING
  filterBySet(param1, equality, param2, limit, collection) {
    let single_document = {};
    const data = [];
    let firestore = getFirestore();
    //  alert(param1+ equality+ param2+ limit+collection);
    console.log(param1);
    console.log(equality);
    console.log(param2);
    console.log(limit);
    console.log(collection);
    firestore
      .collection(collection)
      .where(param1, equality, param2)
      .orderBy("createdAt", "desc")
      .limit(limit)
      .get()
      .then((querySnapshot) => {
        //  firestore.collection("word_set").where("bookmarked","!=", true).orderBy("createdAt", "desc").limit(limit).get().then((querySnapshot) => {
        querySnapshot.forEach(function (doc) {
          single_document = doc.data();
          single_document.id = doc.id;
          data.push(single_document);
        });
        // data = data.sort((a, b) => a.createdAt > b.createdAt);
        this.setState({
          words: data,
          original_words: data,
        });
      });
  }

  FindByLevel = (level) => {
    // props.handleSetFilter(name, parseInt(state.limit), state.table,"level");
    //alert(this.state.collection_name);
    //alert(this.state.limit,);
    //  console.log(this.state.collection_name)
    this.handleSetFilter(
      level,
      this.state.limit,
      this.state.collection_name,
      "level"
    );
  };

  FilterByLevel = (level) => {
    let temp = this.state.original_words;
    //  console.log(temp);
    temp = temp.filter(function (item) {
      return item.level >= level && item.level < 4;
    });
    this.setState({
      words: temp,
      currentWordId: 0,
    });
  };

  RefreshOriginalWords = () => {
    let temp = this.state.original_words;
    this.setState({
      words: temp,
    });
  };

  ClickEdit = () => {
    var index = this.state.currentWordId;
    this.props.history.push("/edit", {
      id: this.state.words[index].id,
      Language1: this.state.words[index].Language1,
      Language2: this.state.words[index].Language2,
      Language3: this.state.words[index].Language3,
      Language4: this.state.words[index].Language4,
      Description1: this.state.words[index].Description1,
      Description2: this.state.words[index].Description2,
      Description3: this.state.words[index].Description3,
      Description4: this.state.words[index].Description4,
      set: this.state.words[index].set,
      sets: this.state.sets,
    });
  };

  RefreshFromDatabase = () => {
    // console.log(this.state.collection_name)
    console.log(this.state.name);
    if (this.state.name == "") {
      this.fetchMainData(5, "word_set");
    } else {
      this.handleSetFilter(
        this.state.name,
        this.state.limit,
        this.state.collection_name,
        this.state.document_name
      );
    }
  };
  //#endregion

  render() {
    return (
      <div className="word-card">
        <CookieWords ReplaceWords={this.ReplaceWords}></CookieWords>
        {/* <Slide
          timeout="{ enter: 10, exit:0}"
          direction="right"
          in={this.state.slide}
        >
        </Slide> */}
        <RecipeReviewCard
          handleBookmark={this.handleBookmark}
          handleSettingsChanged={this.handleSettingsChanged}
          handleAutoPlaySettingsChanged={this.handleAutoPlaySettingsChanged}
          words={this.state.words}
          verbs={this.state.verbs}
          selected={this.state.currentWordId}
          mounted={this.state.mounted}
          settingSpeak={this.state.settingSpeak}
          ClickEdit={this.ClickEdit}
          sets={this.state.sets}
          RefreshFromDatabase={this.RefreshFromDatabase}
          ClickLevel={this.ClickLevel}
          ChangeDate={this.ChangeDate}
          Shuffle={this.Shuffle}
          ToggleLongWords={this.ToggleLongWords}
          longWords={this.state.longWords}
          IframeToggle={this.IframeToggle}
          handleIframeChanage={this.handleIframeChanage}
          collection_name={this.state.collection_name}
          autoPlaySettings={this.state.autoPlaySettings}
          UpdateField={this.UpdateField}
          editWord={this.editWord}
        ></RecipeReviewCard>
        {this.state.iframeShow && (
          <IframeComponent
            language={this.state.iframeLanguage}
            word={this.state.iframeText}
          ></IframeComponent>
        )}

        <PlayWords
          handleBookmark={this.handleBookmark}
          autoPlaySettings={this.state.autoPlaySettings}
          settingSpeak={this.state.settingSpeak}
          words={this.state.words}
          changeCurrentID={this.changeCurrentID}
          ClickLevel={this.ClickLevel}
          ChangeDate={this.ChangeDate}
          FilterByLevel={this.FilterByLevel}
          RefreshOriginalWords={this.RefreshOriginalWords}
          FindByLevel={this.FindByLevel}
        ></PlayWords>

        <SwipeableTemporaryDrawer
          handleChangeSet={this.handleChangeSet}
          handleChangeLevel={this.handleChangeLevel}
          sets={this.state.sets}
          handleSetFilter={this.handleSetFilter}
        ></SwipeableTemporaryDrawer>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    bookmarkWords: (selected, value, collection) =>
      dispatch(bookmarkWords(selected, value, collection)),
    updateUserSettings: (user_settings, uid) =>
      dispatch(updateUserSettings(user_settings, uid)),
    changeLevels: (selected, value, collection) =>
      dispatch(changeLevels(selected, value, collection)),
    changeDates: (selected, collection) =>
      dispatch(changeDates(selected, collection)),
    fieldUpdate: (selected, value, collection, field) =>
      dispatch(fieldUpdate(selected, value, collection, field)),
  };
};

const mapStateToProps = (state) => {
  return {
    //  words:state.firestore.ordered.word_set,
    //  settings: state.firestore.ordered.settings,
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect([
    //  {
    //    collection: 'word_set',
    //    orderBy: [['createdAt','desc']],
    //    limit:50
    //   },
    //  {
    //   collection: 'verbs',
    //  },
    //  {
    //   collection: 'settings'
    //  },
    //  {
    //   collection: 'sets'
    //  }
  ])
)(WordCard);
